import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {Grid} from "@mui/material";

// Utils
import {greyishBlue500} from "assets/jss/main";
import {getTranslation} from "domain/helpers/translations";
import LineItemOptionList from "../../WmsItemList/components/LineItemOptionList";
import {ImageSharp} from "@mui/icons-material";

WmsItemName.propTypes = {
    wmsItem: PropTypes.shape({
        lineItem: PropTypes.shape({
            retailer: PropTypes.object,
            brand: PropTypes.string,
            name: PropTypes.string
        })
    })
};
function WmsItemName({wmsItem}) {
    const retailer = wmsItem?.lineItem?.retailer ?? wmsItem.retailer;

    if (!retailer) {
        return null;
    }

    const logoUrl = getTranslation(retailer)?.logo?.contentUrl;

    return (
        <Grid
            container
            direction={'row'}
            flexWrap={'nowrap'}
        >
            <Grid
                item
                style={{ maxHeight: '40px'}}
            >
                {logoUrl
                    ? <img
                        style={{ borderRadius: '8px'}}
                        width={40}
                        height={40}
                        src={logoUrl}
                        alt={'Retailer Logo'}
                    />
                    : <ImageSharp color={"disabled"} sx={{fontSize: '40px'}}/>
                }
            </Grid>

            <Grid container direction={'column'}>
                <Grid container direction={'column'} marginLeft={2}>
                    <Grid
                        item
                        style={{
                            fontSize: '14px',
                            color: greyishBlue500,
                        }}
                    >
                        {wmsItem.lineItem.brand}
                    </Grid>
                    <Grid
                        item
                        style={{
                            fontSize: '16px',
                            fontWeight: 600,
                        }}
                    >
                        {wmsItem.lineItem.name}
                    </Grid>
                </Grid>

                <Grid container direction={'row'} marginLeft={2} sx={{fontSize: '12px', color: greyishBlue500, fontWeight: 400}}>
                    <LineItemOptionList options={wmsItem.lineItem.options} withOptionName/>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default WmsItemName;
